// removed by extract-text-webpack-plugin
module.exports = {"container":"event-details-buttons__container__tK6bQ","button":"event-details-buttons__button__36IDZ","single-button":"event-details-buttons__single-button__2Smc3","multiple-buttons":"event-details-buttons__multiple-buttons__20u-1","message-host-vert-spacer":"event-details-buttons__message-host-vert-spacer__3kNt_","send-gift-icon-container":"event-details-buttons__send-gift-icon-container__GY7eW","send-gift-icon":"event-details-buttons__send-gift-icon__2vU9O"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/event-details-buttons.scss
// module id = 1335
// module chunks = 1